import React from "react";
import { ComponentWithAs, Icon, IconProps } from "@chakra-ui/react";

const IconComp: ComponentWithAs<"svg", IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon {...props}>
      <path d="m506.617 3.489c-3.411-2.85-7.909-4.041-12.285-3.25l-332 60c-7.139 1.291-12.332 7.506-12.332 14.761v279.98c-15.935-14.28-36.969-22.98-60-22.98-49.626 0-90 40.374-90 90s40.374 90 90 90 90-40.374 90-90v-224.468l302-54.578v167.027c-15.935-14.281-36.969-22.981-60-22.981-49.626 0-90 40.374-90 90s40.374 90 90 90 90-40.374 90-90v-362c0-4.445-1.971-8.661-5.383-11.511zm-416.617 478.511c-33.084 0-60-26.916-60-60s26.916-60 60-60 60 26.916 60 60-26.916 60-60 60zm90-314.953v-79.514l302-54.579v79.514zm242 269.953c-33.084 0-60-26.916-60-60s26.916-60 60-60 60 26.916 60 60-26.916 60-60 60z" />
    </Icon>
  );
};
IconComp.defaultProps = {
  viewBox: "0 0 512 512",
  boxSize: "20px",
};

export default IconComp;
